import isNil from './is-nil';

export default (value: any): string => {
  if (isNil(value)) return '';
  return value.toString();
}
